import React from "react";
import { useWindowDimensions, Platform } from "react-native";

const MOBILE_BREAKPOINT = 768;

interface ResponsiveScreenProps {
  mobile: React.ComponentType<any>;
  desktop: React.ComponentType<any>;
  [key: string]: any;
}

export const ResponsiveScreen: React.FC<ResponsiveScreenProps> = ({
  mobile: MobileComponent,
  desktop: DesktopComponent,
  ...props
}) => {
  const { width } = useWindowDimensions();

  const isMobile =
    Platform.OS === "ios" ||
    Platform.OS === "android" ||
    width < MOBILE_BREAKPOINT;

  if (isMobile) {
    return <MobileComponent {...props} />;
  }

  return <DesktopComponent {...props} />;
};

export function withResponsiveScreen<P = any>(
  MobileComponent: React.ComponentType<P>,
  DesktopComponent: React.ComponentType<P>,
) {
  return function ResponsiveComponent(props: P) {
    return (
      <ResponsiveScreen
        mobile={MobileComponent}
        desktop={DesktopComponent}
        {...props}
      />
    );
  };
}
